export function isAccountAlreadyRegistered(cause: unknown): boolean {
  const candidate = cause && typeof cause === "object" ? cause as { code?: string; message?: string } : {};
  const message = candidate.message?.toLowerCase() ?? "";
  return candidate.code === "user_already_exists" || candidate.code === "email_exists" ||
    message.includes("already registered") || message.includes("already been registered");
}

export function authErrorMessage(cause: unknown): string {
  const candidate = cause && typeof cause === "object" ? cause as { code?: string; status?: number; message?: string } : {};
  const message = candidate.message?.toLowerCase() ?? "";
  if (candidate.status === 429 || message.includes("security purposes") || message.includes("rate limit")) {
    return "El correo ya fue enviado. Espera un minuto antes de solicitar otro.";
  }
  if (isAccountAlreadyRegistered(cause)) {
    return "Este correo ya tiene una cuenta. Inicia sesión o recupera tu contraseña.";
  }
  if (message.includes("password")) return "La contraseña debe tener al menos 8 caracteres.";
  if (message.includes("email")) return "Ingresa un correo electrónico válido.";
  return "No pudimos crear la cuenta. Inténtalo nuevamente.";
}
